import { API } from "@/portal/api";

export const fmtKm = (n) => (n == null || n === "" ? "—" : Number.isFinite(Number(n)) ? `${Number(n).toLocaleString("cs-CZ")} km` : String(n));
export const fmtCZK = (n) => (n == null ? "—" : `${Number(n).toLocaleString("cs-CZ")} Kč`);
export const fmtDate = (s) => (s ? new Date(s + "T00:00:00").toLocaleDateString("cs-CZ", { day: "numeric", month: "numeric", year: "numeric" }) : "—");
export const fmtMonth = (m) => {
  if (!m) return "—";
  const [y, mo] = m.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString("cs-CZ", { month: "long", year: "numeric" });
};
export const monthNow = () => new Date().toISOString().slice(0, 7);
export const photoSrc = (url, token, v) => `${API.replace("/api", "")}${url}?token=${encodeURIComponent(token)}${v ? `&v=${v}` : ""}`;

export const STATUS = {
  free: { label: "Volný", cls: "fl-chip-ok" },
  rented: { label: "Pronajatý", cls: "fl-chip-info" },
  service: { label: "V servisu", cls: "fl-chip-warn" },
};
export const TIRES = { summer: "Letní", winter: "Zimní", allseason: "Celoroční" };

export const dateTone = (d) => {
  if (!d) return "fl-muted";
  const days = Math.round((new Date(d + "T00:00:00") - new Date()) / 86400000);
  return days < 0 ? "fl-bad font-semibold" : days <= 30 ? "fl-warn font-medium" : "fl-text-2";
};
